import _ from "lodash";
import API_URLS from "../utils/apiUrls";
import { openHttpRequest } from "../utils/httpRequest";
import { Article, BlogApiArticle, BlogArticleDetail, BlogArticlesResponse } from "../pages/Blog/types";

const formatArticleDate = (date: string) => {
  if (!date) {
    return "";
  }

  const parsedDate = new Date(date.replace(" ", "T"));
  return Number.isNaN(parsedDate.getTime())
    ? date
    : parsedDate.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
};

const toArticle = (article: BlogApiArticle): Article => ({
  id: article.id,
  slug: article.slug,
  title: article.title,
  excerpt: article.excerpt,
  category: article.category,
  image: article.cover_image,
  author: article.author || "employHER team",
  date: formatArticleDate(article.published_at),
});

export const fetchBlogArticles = async (): Promise<BlogArticlesResponse> => {
  const response = await openHttpRequest().get(API_URLS.blog);
  const articles = _.get(response, "data.data.articles", []);
  const featuredArticles = _.get(response, "data.data.featured_articles", []);
  const mappedArticles = Array.isArray(articles) ? articles.map(toArticle) : [];

  return {
    articles: mappedArticles,
    // Keep the page working until the backend sends the separate featured list.
    featuredArticles: Array.isArray(featuredArticles) && featuredArticles.length > 0
      ? featuredArticles.map(toArticle)
      : mappedArticles.slice(0, 4),
  };
};

export const fetchBlogArticle = async (slug: string): Promise<BlogArticleDetail> => {
  const response = await openHttpRequest().get(`${API_URLS.blog}/${slug}`);
  return _.get(response, "data.data", {});
};

export const subscribeToBlogNewsletter = async (email: string) => {
  try {
    const response = await openHttpRequest().post(API_URLS.subscribe, { email });

    return {
      success: true,
      message: _.get(response, "data.message", "Thanks for subscribing. Please check your inbox."),
    };
  } catch (error) {
    return {
      success: false,
      message: _.get(error, "response.data.message", "Unable to subscribe right now. Please try again."),
    };
  }
};
